import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { WpTokenService } from './wp-token.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class RedirectLoginPageGuard  {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private verifyWpTokenService: WpTokenService
  ) { }

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.route.queryParams.subscribe(params => {
        let sub_state = params['sub_state'];
        if( sub_state == ''){
          localStorage.setItem('sub_state', null);
        } else if (sub_state){
          localStorage.setItem('sub_state', sub_state);
        } else {
          this.router.navigateByUrl('/login');
        }
        resolve(true);
      });
    });
    // this.route.queryParams.subscribe(params => {
    //   let sub_state = params['sub_state'];
    //   if( sub_state == ''){
    //     localStorage.setItem('sub_state', null);
    //   } else if (sub_state){
    //     localStorage.setItem('sub_state', sub_state);
    //   }
    // });
    // this.router.navigateByUrl('/login');
    // return true;
  }
}
